export const HINT_TIMEOUT = 8000;
export const DEFAULT_TASK_TIMEOUT = 30000;
export const TASK_TIMEOUT_MULTIPLIER = 10;
export const TASK_MINIMAL_TIMEOUT = 10000;

// find special characters for remove
export const CLEAN_SPECIAL_REG_EXP = /[^\p{L}\d\s-]/gmu;
export const SPECIAL_CHARACTERS_REG_EXP = CLEAN_SPECIAL_REG_EXP;
